/**
 * Raise the log level if the query is too slow (cost >= limit)
 */
export var SLOW_QUERY_LIMIT = 500; // ms
export var Tags;
(function (Tags) {
    Tags["pending"] = "[PENDING]";
    Tags["success"] = "[SUCCESS]";
    Tags["failure"] = "[FAILURE]";
    Tags["slow"] = "[SLOW]";
})(Tags || (Tags = {}));
export var BEGIN = Symbol('begin');
//# sourceMappingURL=constants.js.map